import React from 'react'
import { css } from '@emotion/css'
import { FormattedMessage } from 'react-intl'
import { theme as deprecatedTheme } from '../../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { LoadingMaskRectangle } from '../../../legacy-design-system/loading-masks'

const Layout = ({
  renderTitle,
  renderCount,
  e2eTestId
}: {
  readonly renderTitle: () => React.ReactNode
  readonly renderCount: () => React.ReactNode
  readonly e2eTestId?: string
}) => {
  return (
    <div
      className={css`
        margin-bottom: 10px;
      `}
      data-e2e={e2eTestId}
    >
      {renderTitle()}
      <span
        className={css`
          margin-left: 0.5em;
          font-family: ${deprecatedTheme.fontFamilies.primaryCondensed};
          font-size: 12px;
          color: ${theme.color.neutral60};
        `}
      >
        {renderCount()}
      </span>
    </div>
  )
}

export function VrThermometerHeader({
  i18nID,
  count,
  e2eTestId
}: {
  readonly i18nID: string
  readonly count: number
  readonly e2eTestId?: string
}) {
  return (
    <Layout
      e2eTestId={e2eTestId}
      renderTitle={() => <FormattedMessage id={i18nID} />}
      renderCount={() => `(${count})`}
    />
  )
}

export function VrThermometerHeaderLoadingView() {
  return (
    <Layout
      renderTitle={() => (
        <LoadingMaskRectangle
          width={100}
          height={19}
          className={css`
            display: inline-block;
          `}
        />
      )}
      renderCount={() => (
        <LoadingMaskRectangle
          width={25}
          height={19}
          className={css`
            display: inline-block;
          `}
        />
      )}
    />
  )
}
